// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import TextInput from './../../../../../components/TextInput';
import SelectInput from './../../../../../components/SelectInput';
import { translate } from "react-i18next";

import {
    PHOTOS_TYPE,
    VIDEO_TYPE,
    SHP_TYPE,
    ORTO_TYPE,
    DTM_TYPE,
    DRONE_TYPE,
    MODEL_TYPE,
    RESOURCE_TYPE
} from '../../../../../types/upload';

const GroupAttributesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: calc(100% - 10px);
`;

const LeftAlignedP = styled.p`
  align-self: flex-start;
  white-space: pre-wrap;
  margin: 5px 0px;
  color: #333333;
  font-size: 13px;
`;

const StyledInputWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

class GroupAttributesForm extends React.Component {
    constructor(): void {
        super();

        this.state = {
            projectId: 0,
            url: "",
            invalidUrl: false,
            description: "",
            layerName: "",
            minValue: 0,
            maxValue: 0,
            timeZoneName: '(UTC) GMT Standard Time',
        };
    }

    componentDidMount() {
        if (this.props.chosenFlight) {
            this.setState({ projectId: this.props.chosenFlight.id })
        }
    }

    componentDidUpdate() {
        //Clear chosen TextInput and groupAttributes values to disabled UploadButton. For loadType without upload files.
        if (this.props.clear === true) {
            switch (this.props.loadType) {
                case MODEL_TYPE:
                    this.setState({ description: "", url: "" });
                    this.props.onChangeAttributes({
                        clear: false,
                        valid: false,
                        attributes: {
                            projectId: this.state.projectId,
                            url: "",
                            description: "",
                            timeZoneName: ""
                        }
                    })
                    break;
                default:
                    return (null);
            }
        }
    }

    validateDrone() {
        const { timeZoneName, projectId } = this.state;
        if (!timeZoneName) return false;
        if (!Number(projectId)) return false;
        return true;
    }

    onChangeDrone() {
        this.props.onChangeAttributes({
            clear: false,
            valid: this.validateDrone(),
            attributes: {
                projectId: this.state.projectId,
                timeZoneName: this.state.timeZoneName
            },
        });
    }

    validateModel() {
        const { projectId, url, description } = this.state;
        const pattern = new RegExp('^((https?://)?sketchfab.com/models/)?[A-Za-z0-9]+(/embed)?$');
        //check url first!!!
        if (!pattern.test(url)) {
            this.setState({ invalidUrl: true })
            return false;
        }
        else {
            this.setState({ invalidUrl: false })
        }
        if (!Number(projectId)) return false;
        if (!description) return false;
        return true;
    }

    createValidUrl() {
        const { url } = this.state;
        //create valid url to sketchfab API embed
        var userId = 0;
        var urlPart = url.split('/')

        if (urlPart.length === 1) {
            userId = url;
        }
        else if (urlPart.length === 3 || urlPart.length === 5) {
            userId = urlPart[urlPart.length - 1];
        }
        else {
            userId = urlPart[urlPart.length - 2];
        }

        this.setState({
            invalidUrl: false,
        });
        return "https://sketchfab.com/models/" + userId + "/embed";
    }

    onChangeModel() {
        var isValid = this.validateModel();
        this.props.onChangeAttributes({
            clear: false,
            valid: isValid,
            attributes: {
                projectId: this.state.projectId,
                url: isValid ? this.createValidUrl() : "",
                description: this.state.description
            },
        });
    }

    validateResource() {
        const { description, projectId } = this.state;
        if (!description) return false;
        if (!Number(projectId)) return false;
        return true;
    }

    onChangeResource() {
        this.props.onChangeAttributes({
            clear: false,
            valid: this.validateResource(),
            attributes: {
                projectId: this.state.projectId,
                description: this.state.description
            },
        });
    }

    validateLayer() {
        const { layerName, projectId } = this.state;
        if (!layerName) return false;
        if (!Number(projectId)) return false;
        return true;
    }

    onChangeLayer() {
        this.props.onChangeAttributes({
            clear: false,
            valid: this.validateLayer(),
            attributes: {
                projectId: this.state.projectId,
                layerName: this.state.layerName
            },
        });
    }

    validateDTM() {
        const { layerName, minValue, maxValue, projectId } = this.state;
        if (!layerName) return false;
        if (!minValue && !maxValue) return false;
        if (!Number(projectId)) return false;
        return true;
    }

    onChangeDTM() {
        this.props.onChangeAttributes({
            clear: false,
            valid: this.validateDTM(),
            attributes: {
                projectId: this.state.projectId,
                layerName: this.state.layerName,
                minValue: this.state.minValue,
                maxValue: this.state.maxValue,
            },
        });
    }

    render() {
        const {
            onChangeAttributes,
            loadType,
            t,
            disabled
        } = this.props;
        const { rawData, chosenFlight, timeZonesNames } = this.props;
        const flightsData = rawData.map(row => {
            return {
                label: row.projectName,
                value: row.id
            }
        });
        flightsData.unshift({
            label: t('No mission selected'),
            value: 0
        });
        const selectedOption = chosenFlight
            ? chosenFlight.id
            : flightsData[0].value;

        switch (loadType) {
            case PHOTOS_TYPE:
            case VIDEO_TYPE:
                return (
                    <GroupAttributesWrapper>
                        <LeftAlignedP>{t('Select project')}:</LeftAlignedP>
                        <SelectInput
                            disabled={disabled}
                            style={{ width: '250px' }}
                            defaultValue={selectedOption}
                            onChange={event => {
                                onChangeAttributes({
                                    valid: Boolean(event.target.value),
                                    attributes: {
                                        projectId: event.target.value,
                                    }
                                })
                            }}>
                            {flightsData.map((flight) => {
                                const { value, label } = flight;
                                return (
                                    <option
                                        value={value}
                                        key={`mission_${value}_upload`}
                                    >
                                        {label}
                                    </option>
                                )
                            })}
                        </SelectInput>
                    </GroupAttributesWrapper>
                );
            case DRONE_TYPE:
                return (
                    <GroupAttributesWrapper>
                        <LeftAlignedP>{t('Select project')}:</LeftAlignedP>
                        <SelectInput
                            disabled={disabled}
                            style={{ width: '250px' }}
                            defaultValue={selectedOption}
                            onChange={event => {
                                this.setState({ projectId: event.target.value }, this.onChangeDrone);
                            }} >
                            {flightsData.map((flight) => {
                                const { value, label } = flight;
                                return (
                                    <option
                                        value={value}
                                        key={`mission_${value}_upload`}
                                    >
                                        {label}
                                    </option>
                                )
                            })}
                        </SelectInput>
                        <LeftAlignedP>{t('Select time zone')}:</LeftAlignedP>
                        <SelectInput
                            disabled={disabled}
                            style={{ width: '250px' }}
                            defaultValue={this.state.timeZoneName}
                            onChange={event => {
                                this.setState({ timeZoneName: event.target.value }, this.onChangeDrone);
                            }} >
                            {timeZonesNames.map((timeZoneName) => {
                                return (
                                    <option
                                        value={timeZoneName}
                                        key={`timeZone_${timeZoneName}`}
                                    >
                                        {timeZoneName}
                                    </option>
                                )
                            })}
                        </SelectInput>
                    </GroupAttributesWrapper>
                );

            case ORTO_TYPE:
                return (
                    <GroupAttributesWrapper>
                        <LeftAlignedP>{t('Select project')}:</LeftAlignedP>
                        <SelectInput
                            disabled={disabled}
                            name='ProjectId'
                            style={{ width: '250px' }}
                            defaultValue={selectedOption}
                            onChange={event => {
                                this.setState({ projectId: event.target.value }, this.onChangeLayer);
                            }} >
                            {flightsData.map((flight) => {
                                const { value, label } = flight;
                                return (
                                    <option
                                        value={value}
                                        key={`mission_${value}_upload`}
                                    >
                                        {label}
                                    </option>
                                )
                            })}
                        </SelectInput>
                        <LeftAlignedP>
                            {t('Layer name')}
                        </LeftAlignedP>
                        <StyledInputWrapper>
                            <TextInput
                                disabled={disabled}
                                style={{ width: 'calc(100% - 10px)' }}
                                type='text'
                                placeholder={t('ex Orthomosaic')}
                                tip={t('Layer with that name will be created in current project')}
                                onChange={event => {
                                    this.setState({ layerName: event.target.value }, this.onChangeLayer);
                                }} />
                        </StyledInputWrapper>
                    </GroupAttributesWrapper>
                );

            case DTM_TYPE:
                return (
                    <GroupAttributesWrapper>
                        <LeftAlignedP>{t('Select project')}:</LeftAlignedP>
                        <SelectInput
                            disabled={disabled}
                            name='ProjectId'
                            style={{ width: '250px' }}
                            defaultValue={selectedOption}
                            onChange={event => {
                                this.setState({ projectId: event.target.value }, this.onChangeDTM);
                            }} >
                            {flightsData.map((flight) => {
                                const { value, label } = flight;
                                return (
                                    <option
                                        value={value}
                                        key={`mission_${value}_upload`}
                                    >
                                        {label}
                                    </option>
                                )
                            })}
                        </SelectInput>
                        <LeftAlignedP>
                            {t('Layer name')}
                        </LeftAlignedP>
                        <TextInput
                            disabled={disabled}
                            style={{ width: 'calc(100% - 10px)' }}
                            type='text'
                            placeholder={t('ex Orthomosaic')}
                            value={this.state.layerName}
                            tip={t('Layer with that name will be created in current project')}
                            onChange={event => {
                                this.setState({ layerName: event.target.value }, this.onChangeDTM);
                            }} />
                        <LeftAlignedP>
                            {t('Minimum color scale value')}
                        </LeftAlignedP>
                        <TextInput
                            disabled={disabled}
                            style={{ width: 'calc(100% - 10px)' }}
                            type='number'
                            placeholder={t('100')}
                            value={this.state.minValue}
                            tip={t('Minimum color scale value')}
                            onChange={event => {
                                this.setState({ minValue: event.target.value }, this.onChangeDTM);
                            }} />
                        <LeftAlignedP>
                            {t('Maximum color scale value')}
                        </LeftAlignedP>
                        <TextInput
                            disabled={disabled}
                            style={{ width: 'calc(100% - 10px)' }}
                            type='number'
                            placeholder={t('200')}
                            value={this.state.maxValue}
                            tip={t('Maximum color scale value')}
                            onChange={event => {
                                this.setState({ maxValue: event.target.value }, this.onChangeDTM);
                            }} />
                    </GroupAttributesWrapper>
                );

            case SHP_TYPE:
                return (
                    <GroupAttributesWrapper>
                        <LeftAlignedP>{t('Select project')}:</LeftAlignedP>
                        <SelectInput
                            disabled={disabled}
                            name='ProjectId'
                            style={{ width: '250px' }}
                            defaultValue={selectedOption}
                            onChange={event => {
                                this.setState({ projectId: event.target.value }, this.onChangeLayer);
                            }} >
                            {flightsData.map((flight) => {
                                const { value, label } = flight;
                                return (
                                    <option
                                        value={value}
                                        key={`mission_${value}_upload`}
                                    >
                                        {label}
                                    </option>
                                )
                            })}
                        </SelectInput>
                        <LeftAlignedP>
                            {t('Layer name')}
                        </LeftAlignedP>
                        <StyledInputWrapper>
                            <TextInput
                                disabled={disabled}
                                style={{ width: 'calc(100% - 10px)' }}
                                type='text'
                                placeholder={t('ex Buildings')}
                                tip={t('Layer with that name will be created in current project')}
                                onChange={event => {
                                    this.setState({ layerName: event.target.value }, this.onChangeLayer);
                                }} />
                        </StyledInputWrapper>
                    </GroupAttributesWrapper>
                );

            case RESOURCE_TYPE:
                return (
                    <GroupAttributesWrapper>
                        <LeftAlignedP>{t('Select project')}:</LeftAlignedP>
                        <SelectInput
                            disabled={disabled}
                            name='ProjectId'
                            style={{ width: '250px' }}
                            defaultValue={selectedOption}
                            onChange={event => {
                                this.setState({ projectId: event.target.value }, this.onChangeResource);
                            }} >
                            {flightsData.map((flight) => {
                                const { value, label } = flight;
                                return (
                                    <option
                                        value={value}
                                        key={`mission_${value}_upload`}
                                    >
                                        {label}
                                    </option>
                                )
                            })}
                        </SelectInput>
                        <LeftAlignedP>
                            {t('Attachment description')}
                        </LeftAlignedP>
                        <StyledInputWrapper>
                            <TextInput
                                disabled={disabled}
                                style={{ width: 'calc(100% - 10px)' }}
                                type='text'
                                placeholder={t('description')}
                                tip={t('Attachment description')}
                                onChange={event => {
                                    this.setState({ description: event.target.value }, this.onChangeResource);
                                }} />
                        </StyledInputWrapper>
                    </GroupAttributesWrapper>
                );

            case MODEL_TYPE:
                return (
                    <GroupAttributesWrapper>
                        <LeftAlignedP>{t('Select project')}:</LeftAlignedP>
                        <SelectInput
                            disabled={disabled}
                            name='ProjectId'
                            style={{ width: '250px' }}
                            defaultValue={selectedOption}
                            onChange={event => {
                                this.setState({ projectId: event.target.value }, this.onChangeModel);
                            }} >
                            {flightsData.map((flight) => {
                                const { value, label } = flight;
                                return (
                                    <option
                                        value={value}
                                        key={`mission_${value}_upload`}
                                    >
                                        {label}
                                    </option>
                                )
                            })}
                        </SelectInput>
                        <LeftAlignedP>
                            {t('Model description')}
                        </LeftAlignedP>
                        <TextInput
                            disabled={disabled}
                            name='Url'
                            style={{ width: 'calc(100% - 10px)' }}
                            type='text'
                            placeholder='*link'
                            value={this.state.url}
                            tip={t('3D Model link on sketchfab')}
                            invalid={this.state.invalidUrl}
                            onChange={event => {
                                this.setState({ url: event.target.value }, this.onChangeModel);
                            }} />
                        <TextInput
                            disabled={disabled}
                            name='Description'
                            style={{ width: 'calc(100% - 10px)' }}
                            type='text'
                            placeholder={'*' + t('description')}
                            value={this.state.description}
                            tip={t('Model name')}
                            onChange={event => {
                                this.setState({ description: event.target.value }, this.onChangeModel);
                            }} />
                    </GroupAttributesWrapper>
                );

            default:
                return (null);
        }
    }
}

const mapStateToProps = state => ({
    chosenFlight: state.flightManager.get('chosenFlight'),
    rawData: state.flightManager.get('rawData'),
    timeZonesNames: state.flightManager.get('timeZonesNames'),
});

export default translate("translations")(connect(mapStateToProps)(GroupAttributesForm));


// WEBPACK FOOTER //
// ./src/containers/content/grid/uploadPanel/groupAttributesForm/GroupAttributesForm.jsx